A location inferred from the provided address details.

SEEK will attempt to match the address details to a location in our hierarchy on a best-effort basis.

This query accepts browser tokens that include the `query:ontologies` or `query:enhanced-job-posting` scope.
